import List from 'containers/JobApplications/List';
import Show from 'containers/JobApplications/Show';

export default { List, Show };
